module.exports = __webpack_public_path__ + "img/pic2.be3f99ae.png";